import {
    EVERYONE_SENTINEL,
    PipelineCardSort,
    PipelineEntityId,
    PipelineEntityType,
    UserId,
} from "@sp-crm/core";
import type { AppRouter } from "@sp-crm/server/rpc";
import type { inferProcedureOutput } from "@trpc/server";

export type PipelineSummary = inferProcedureOutput<AppRouter["pipeline"]["list"]>[number];

export type PipelineStageSummary = PipelineSummary["stages"][number];

export type BoardStageCard = inferProcedureOutput<
    AppRouter["pipeline"]["boardStage"]
>[number];

export interface ReferralPipelineBoardQuery {
    search: string;
    assignee: UserId | typeof EVERYONE_SENTINEL | "";
    sort: PipelineCardSort;
}

export const referralPipelineCardType = "ReferralPipelineCard" as const;

export interface PipelineEntityRef {
    entityType: PipelineEntityType;
    entityId: PipelineEntityId;
}

export const referralPipelineSortOptions: { value: PipelineCardSort; text: string }[] = [
    { value: "updatedAtDesc", text: "Updated date (most recent)" },
    { value: "updatedAtAsc", text: "Updated date (oldest)" },
    { value: "createdAtDesc", text: "Created date (most recent)" },
    { value: "createdAtAsc", text: "Created date (oldest)" },
    { value: "nameAsc", text: "Name (A-Z)" },
    { value: "nameDesc", text: "Name (Z-A)" },
];
